


import { json, Navigate, useNavigate } from 'react-router-dom';
import { doc, setDoc, updateDoc } from 'firebase/firestore';
import { db, firebaseAuth } from './utils/firebase-config';
import { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';

import logo from "./assets/version2/logo.png";
import group1 from "./assets/version2/group1.png";
import group2 from "./assets/version2/group2.png";
import group3 from "./assets/version2/group3.png";
 


function Home() {
    const navigate = useNavigate();





    const [logado, setLogado] = useState(false);
    const [dataHome, setDataHome] = useState([]);
    const [emailAtual, setEmailAtual] = useState('');
    const [notif, setNotif] = useState('none');
    const [notif2, setNotif2] = useState('none');
    const [have, setHave] = useState(false);

  var runtime = true;
    function master(params) {
        

    onAuthStateChanged(firebaseAuth, async (currentUser) => {
        if (currentUser) {setLogado(true);
        





            fetch('https://apilumera.shop/api/consultausuario', {
                method: 'POST',
                body: JSON.stringify({
                    email: currentUser.email
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                }
              })
              .then((response) => response.json())
              .then((data) => {
        
        
                setDataHome(data.notificacoes)
               
                
                if(data.notificacoes.length > 0){

               
   if(localStorage.getItem("ultimapostagemRef") != data.notificacoes[data.notificacoes.length - 1]){   
          
                                                    
                     setHave(true);
      
                
                     if(runtime == true){
                      runtime = false;
                   
                     setTimeout(() => {
                      var colorr = 0;
var indo = true;

  setInterval(()=> {
    if(indo == true){
        colorr = colorr + 20; 
    }
    if(indo == false){
         colorr = colorr - 20;
    }
    if(colorr > 255){
        indo = false;
    }
    if(colorr <= 0){
        indo = true;
    }
  
    if(document.querySelector('.fadeeffect') != null) {
 document.querySelector('.fadeeffect').style.backgroundColor = `rgb(255,${colorr},${colorr})`
    }
       
    
},100);
                     }, 3000);




  }


              } 


 }





        
              })
              .catch((err) => {
                console.log(err.message);
              });

















            
    }
      });





    }















      function logOut(params) {
        signOut(firebaseAuth); 
        setLogado(false);
      }


useEffect(()=> {
master();

}, []);





async function testRegister() {
    await updateDoc(doc(db, 'clientes', `${'althertechadm@gmail.com'}`), {

        nome: {maria: 222, joão: 333},
        item01: {nome: 'item01', descricao: 'item01 01 01'},
        item02: {nome: 'item01', descricao: 'item01 01 01'},
        item03: {nome: 'MASTER', descricao: 'MASTER'}
     
    
    
      });
}

if(window.location.href.slice(window.location.href.length - 1, window.location.href.length) != '/') {
    document.querySelector('.oisumida').style.display = 'none';
} else {

    document.querySelector('.oisumida').style.display = 'block';
    
}













   function notificacaolida() {
    localStorage.setItem("ultimapostagemRef", dataHome[dataHome.length - 1]);
    setHave(false);
 
   }














  return (
    <div className="App">
      
      {
        // APP MASTER
      }





    <div style={{backgroundColor: 'rgb(250,250,250)', color: 'white',
        height: '80vh', width: '300px', position: 'absolute',
        borderRadius: '8px',
        top: '80px', right: '0px', zIndex: '900', display: notif2, padding: '10px 20px',
        flexFlow: 'column', overflowY: 'scroll', alignItems: 'start'
    }}
    onMouseLeave={()=> setNotif2('none')}
    >
        <h4 style={{color: 'black'}}>Notificações</h4>

      
        
        {
            dataHome.map((data, index)=> {
                return <>
                
                <div style={{color: 'rgb(63, 63, 63)', display: 'flex', fontSize: '14px', textAlign: 'start',
            fontFamily: 'Inter, serif', fontWeight: '100', paddingTop: '10px'
        }}>
        <i class="bi bi-info-circle" style={{fontSize: '30px', marginRight: '10px', color: 'rgb(117, 0, 117)'}}></i> 

       <a> {data.split('###master')[0].replaceAll(' ', '') == 'pendencia' ? 'Nova Pendência de nome' : 'Nova Mensagem na pendência'}  
      {data.split('###master')[0].replaceAll(' ', '') == 'pendencia' ? 
    <><a style={{fontWeight: 'bold'}}> {data.split('###master')[2]} </a> no projeto <a style={{fontWeight: 'bold'}}> {data.split('###master')[1]}</a></>  
    :
    <><a style={{fontWeight: 'bold'}}> {data.split('###master')[2]} </a> </>
    }
        </a> 
        </div>
                
                
                </>
            })
        }


   
    </div>










































      
<header id="site-header" className="main-header main-header-overlay" data-sticky-header="true"
>
    <section className="lqd-section desktop-header md:hidden">
        <div className="container-fluid p-0">
            <div className="flex flex-wrap w-full justify-between">
                <div className="navbar-brand-plain w-15percent py-30 flex"><a  className="navbar-brand flex relative p-0 leading-1/4em"><span className="navbar-brand-inner post-rel"><img className="logo-default" src={logo} alt="Lumera" /></span></a></div>
                <div
                className="module-primary-nav w-60percent flex justify-end lg:w-85percent">
                    <div className="navbar-collapse inline-flex lqd-submenu-cover p-0" id="main-header-collapse" aria-expanded="false" role="navigation">
                        <ul id="primary-nav" className="main-nav flex justify-center reset-ul inline-ul lqd-menu-counter-right lqd-menu-items-inline main-nav-hover-default lqd-submenu-toggle-hover"
                        data-localscroll="true" data-localscroll-options="{&quot;itemsSelector&quot; : &quot;>li > a&quot;, &quot;trackWindowScroll&quot;: true, &quot;includeParentAsOffset&quot;: true}">
                          {logado && <>
                          <li className="is-active"><a className="leading-1/4em text-blue-700" 
                            onClick={()=> {navigate('/main'); document.querySelector('section').style.display = 'none'}}
                            style={{color: '#985EAC', cursor: 'pointer'}}
                            >Projetos</a></li>
                          </>}  
                            <li className="menu-item-has-children"><a className="leading-1/4em text-blue-700" style={{cursor: 'pointer'}} onClick={()=> navigate('/sobre')}>Sobre <span className="submenu-expander"></span> <span className="link-icon inline-flex hide-if-empty right-icon"></span></a></li>
                            <li
                            className="menu-item-has-children"><a className="leading-1/4em text-blue-700">Como usar <span className="submenu-expander"></span> </a></li>
                                <li><a className="leading-1/4em text-blue-700" >Contato</a></li>
                           
                        </ul>
                    </div>
            </div>
            <div className="w-25percent flex items-center justify-end lg:hidden">
                    {!logado? 
                    <>
                 
               
                          <div className="widget-text-editor mr-15">
                          <a className="leading-1/4em text-blue-700" 
                          onClick={()=> navigate('/login')}
                          style={{cursor: 'pointer'}}
                          >Login <span className="submenu-expander"></span> <span className="link-icon inline-flex hide-if-empty right-icon"></span></a></div>
                      <div className="module-btn px-0/5em">
                          <a className="leading-1/4em text-blue-700" 
                           onClick={()=> navigate('/register')}
                           style={{cursor: 'pointer'}}
      
                          >Cadastrar-se <span className="submenu-expander"></span> <span className="link-icon inline-flex hide-if-empty right-icon"></span></a>
                      </div>
                      </>
                      : <>


   <div style={{display: 'none'}}>     {document.querySelectorAll('.items-center')[2].style.display = 'none'}</div>

<div
    style={{
      paddingRight: 45,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 10
    }}
  >
    <div style={{display: 'flex'}}>
    {
      have && <>
      
    <div className="fadeeffect" style={{width: '4px', height: '4px',
       backgroundColor: 'red', borderRadius: '50%', marginTop: '20px'}}></div>

      </>
    }


 <i className="bi bi-bell" style={{ fontSize: 18, cursor: 'pointer' }} onClick={()=> {
    setNotif('flex');
    notificacaolida();
    }}/>


    </div>
    <i className="bi bi-person-circle" style={{ fontSize: 28, cursor: 'pointer' }} 
    onClick={()=> navigate('/conta')}
    />
  </div>

    <div style={{backgroundColor: 'rgb(250,250,250)', color: 'white',
        height: '80vh', width: '300px', position: 'absolute',
        borderRadius: '8px',
        top: '80px', display: notif, padding: '10px 20px',
        flexFlow: 'column', overflowY: 'scroll', alignItems: 'start'
    }}
    onMouseLeave={()=> setNotif('none')}
    >
        <h4 style={{color: 'black'}}>Notificações</h4>

      
        
        {
            dataHome.map((data, index)=> {
                return <>
                
                <div style={{color: 'rgb(63, 63, 63)', display: 'flex', fontSize: '14px', textAlign: 'start',
            fontFamily: 'Inter, serif', fontWeight: '100', paddingTop: '10px'
        }}>
        <i class="bi bi-info-circle" style={{fontSize: '30px', marginRight: '10px', color: 'rgb(117, 0, 117)'}}></i> 

       <a> {data.split('###master')[0].replaceAll(' ', '') == 'pendencia' ? 'Nova Pendência de nome' : 'Nova Mensagem na pendência'}  
      {data.split('###master')[0].replaceAll(' ', '') == 'pendencia' ? 
    <><a style={{fontWeight: 'bold'}}> {data.split('###master')[2]} </a> no projeto <a style={{fontWeight: 'bold'}}> {data.split('###master')[1]}</a></>  
    :
    <><a style={{fontWeight: 'bold'}}> {data.split('###master')[2]} </a> </>
    }
        </a> 
        </div>
                
                
                </>
            })
        }


   
    </div>




                      </>
                    }
          

            </div>
        </div>
        </div>
    </section>
    <div className="lqd-mobile-sec relative" style={{position: 'fixed', top: '0px', width: '100%'}}>
        <div className="lqd-mobile-sec-inner navbar-header flex items-stretch w-full">
            <div className="lqd-mobile-modules-container empty"></div>
            <button type="button" className="bg-transparent border-none navbar-toggle collapsed nav-trigger style-mobile flex relative items-center justify-end p-0" data-ld-toggle="true" data-bs-toggle="collapse" data-bs-target="#lqd-mobile-sec-nav"
            aria-expanded="false" data-toggle-options="{ &quot;changeClassnames&quot;:  {&quot;html&quot;:  &quot;mobile-nav-activated&quot;} }"><span className="sr-only">Menu</span> <span className="bars inline-block relative z-1"><span className="bars-inner flex flex-col w-full h-full"><span className="bar inline-block"></span> <span className="bar inline-block"></span> <span className="bar inline-block"></span></span>
                </span>
            </button> <a className="navbar-brand flex relative leading-1/4em"><span className="navbar-brand-inner">
                
                <img className="logo-default" src={logo} style={{maxHeight: '30px'}} alt="Lumera 3D" />
                
                </span></a></div>
        <div className="lqd-mobile-sec-nav w-full absolute z-10">
            <div className="mobile-navbar-collapse navbar-collapse collapse w-full" id="lqd-mobile-sec-nav" aria-expanded="false" role="navigation">
                <ul id="mobile-primary-nav" className="reset-ul lqd-mobile-main-nav main-nav lqd-submenu-toggle-hover">
                   {logado && <> <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-7550 current_page_item menu-item-7601" style={{cursor: 'pointer'}} onClick={()=> navigate('/main')}><a className="leading-1/4em">Projetos</a></li></>}
                    <li className="menu-item-has-children" style={{cursor: 'pointer'}} onClick={()=> navigate('/sobre')}><a  className="leading-1/4em">Sobre <span className="submenu-expander absolute"></span> <span className="link-icon inline-flex hide-if-empty right-icon"><i className="lqd-icn-ess icon-ion-ios-arrow-down"></i></span></a></li>
                    <li
                    className="menu-item-has-children"><a  className="leading-1/4em">Como Usar <span className="submenu-expander absolute"></span> <span className="link-icon inline-flex hide-if-empty right-icon"><i className="lqd-icn-ess icon-ion-ios-arrow-down"></i></span></a></li>
                        <li><a  className="leading-1/4em">Contato</a></li>
                        <li><a  className="leading-1/4em" onClick={()=> {
                            setNotif2('flex');
                            notificacaolida();
                            }}>Notificações</a>
                            
                                                {
      have && <>
        <div style={{position: 'absolute', paddingTop: '6px'}}>
    <div className="fadeeffect" style={{width: '5px', height: '5px',
       backgroundColor: 'red', borderRadius: '50%', marginTop: '20px'}}></div></div>

      </>
    }
                            
                            </li>
                </ul>
            </div>
        </div>
    </div>
</header>


    <div id="wrap" style={{marginTop: '50px'}}>
        <div className="lqd-sticky-placeholder hidden"></div>
        <header id="site-header" className="main-header main-header-overlay" data-sticky-header="true" data-sticky-values-measured="true" data-sticky-options="{&quot;disableOnMobile&quot;: true}">
        

    </header>
    <main className="content bg-cover bg-white" id="lqd-site-content" 
                                                            style={{backgroundImage: "url(./assets/images/demo/digital-hub/bg-min.png)"}}>
        <div id="lqd-contents-wrap">
    
    






























    

        <section className="lqd-section services pt-50 ca-initvalues-applied lqd-animations-done" 
        id="services" data-custom-animations="true" 
        data-ca-options="{&quot;animationTarget&quot;: &quot;.animation-element&quot;,
             &quot;ease&quot;: &quot;power4.out&quot;,
              &quot;initValues&quot;: {&quot;y&quot;: &quot;60px&quot;, &quot;rotationZ&quot; : 5,
                 &quot;opacity&quot; : 0, &quot;transformOrigin&quot;: &quot;50% 50% 120px&quot;} , &quot;animations&quot;: {&quot;y&quot;: &quot;0px&quot;, &quot;rotationZ&quot; : 0, &quot;opacity&quot; : 1, &quot;transformOrigin&quot;: &quot;50% 50% 0px&quot;}}">
            <div className="container">
                <div className="row">
                    <div className="col col-xl-4 col-12 mb-30 sm:py-0">
                        <div className="iconbox flex flex-grow-1 relative items-center iconbox-custombg animation-element lqd-unit-animation-done" >
                            <div className="iconbox-icon-wrap mr-60">
                                <div className="iconbox-icon-container relative z-1 m-0 w-55 h-55 text-primary text-54">
                                    <span className="icon-custom-bg">
                                        <svg className="w-145" viewBox="0 0 200 200">
                                            <path fill="#F2F4F8" d="M54.4, -27.6C66, -11.2, 68, 14.6, 57.3, 31.9C46.6, 49.1, 23.3, 57.8, -0.3, 58C-23.9, 58.2, -47.9, 49.8, -55.4, 34.4C-63, 18.9, -54.2, -3.6, -42.2, -20.3C-30.3, -36.9, -15.1, -47.6, 3.1, -49.3C21.3, -51.1, 42.7, -44.1, 54.4, -27.6Z" transform="translate(100 100)"></path>
                                        </svg>
                                    </span>
                              <img src={group1} />
                                </div>
                            </div>
                            <div className="contents">
                                <h3 className="lqd-iconbox-heading mb-0/7em text-18">Controle Total da Equipe</h3>
                                <p>Organize sua equipe de forma eficiente. Defina permissões, atribua funções e facilite a colaboração no gerenciamento de seus projetos 3D.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col col-xl-4 col-12 mb-30 sm:py-0">
                        <div className="iconbox flex flex-grow-1 relative items-center iconbox-custombg animation-element lqd-unit-animation-done" >
                            <div className="iconbox-icon-wrap mr-60">
                                <div className="iconbox-icon-container relative z-1 m-0 w-55 h-55 text-primary text-54">
                                    <span className="icon-custom-bg">
                                        <svg className="w-145" viewBox="0 0 200 200">
                                            <path fill="#F2F4F8" d="M54.4, -27.6C66, -11.2, 68, 14.6, 57.3, 31.9C46.6, 49.1, 23.3, 57.8, -0.3, 58C-23.9, 58.2, -47.9, 49.8, -55.4, 34.4C-63, 18.9, -54.2, -3.6, -42.2, -20.3C-30.3, -36.9, -15.1, -47.6, 3.1, -49.3C21.3, -51.1, 42.7, -44.1, 54.4, -27.6Z" transform="translate(100 100)"></path>
                                        </svg>
                                    </span>
                                    <img src={group2} />
                                </div>
                            </div>
                            <div className="contents">
                                <h3 className="lqd-iconbox-heading mb-0/7em text-18">Gerenciamento de Modelos 3D</h3>
                                <p>Envie e organize seus modelos 3D diretamente na plataforma. Mantenha todos os arquivos atualizados e acessíveis para sua equipe, sem complicações.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col col-xl-4 col-12 mb-30 sm:py-0">
                        <div className="iconbox flex flex-grow-1 relative items-center iconbox-custombg animation-element lqd-unit-animation-done" >
                            <div className="iconbox-icon-wrap mr-60">
                                <div className="iconbox-icon-container relative z-1 m-0 w-55 h-55 text-primary text-54">
                                    <span className="icon-custom-bg">
                                        <svg className="w-145" viewBox="0 0 200 200">
                                            <path fill="#F2F4F8" d="M54.4, -27.6C66, -11.2, 68, 14.6, 57.3, 31.9C46.6, 49.1, 23.3, 57.8, -0.3, 58C-23.9, 58.2, -47.9, 49.8, -55.4, 34.4C-63, 18.9, -54.2, -3.6, -42.2, -20.3C-30.3, -36.9, -15.1, -47.6, 3.1, -49.3C21.3, -51.1, 42.7, -44.1, 54.4, -27.6Z" transform="translate(100 100)"></path>
                                        </svg>
                                    </span>
                                    <img src={group3} />
                                </div>
                            </div>
                            <div className="contents">
                                <h3 className="lqd-iconbox-heading mb-0/7em text-18">Gestão de Pendências</h3>
                                <p>Diga adeus ao caus dos e-mails! Com o Lumera 3D, acompanhe pendencias do projeto em um só lugar. Centralize informações, delegue tarefas e mantenha sua equipe sempre atualizada.
                                            
                                        </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>














        <section className="lqd-section footer-menu pt-50 pb-20" style={{backgroundColor: 'rgba(213, 213, 213, 0.49)', marginTop: '50px', borderTop: '2px solid rgb(227, 227, 227)'}}>
            <div className="container">
                <div className="row">
                    <div className="w-45percent flex flex-col justify-start p-0 lg:w-full">
                        <div className="flex flex-col py-10 pr-90 pl-10 mb-30 module-content">
                            <div className="lqd-imggrp-single block relative mb-35">
                            
                                </div>
                                <div className="ld-fancy-heading relative">
                                 
                                 
                                 <img src={logo} style={{width: '300px'}}></img>
                                </div>
                            
                            </div>
                        </div>
                        <div className="w-55percent flex p-0 lg:w-full">
                            <div className="w-full flex flex-wrap p-10 mb-30">
                                <div className="w-33percent sm:w-50percent">
                                    <div className="module-list flex flex-col justify-start mb-30 p-10">
                                        <div className="ld-fancy-heading relative" style={{display: 'flex'}}>
                                            <h3 className="ld-fh-element inline-block relative mb-1/35em text-16 uppercase tracking-1">Lumera 3D</h3>
                                        </div>
                                        <div className="lqd-fancy-menu lqd-custom-menu relative lqd-menu-td-none">
                                            <ul className="reset-ul">
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400" 
                                                    style={{cursor: 'pointer'}}
                                                    onClick={()=> navigate('/sobre')}
                                                    >Sobre nós</a>
                                                </li>
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400" >Como usar</a>
                                                </li>
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400"
                                                    onClick={()=> navigate('/main')}
                                                    style={{cursor: 'pointer'}}
                                                    >Acessar meus Projetos</a>
                                                </li>
                                            
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-33percent sm:w-50percent">
                                    <div className="module-list flex flex-col justify-start mb-30 p-10">
                                        <div className="ld-fancy-heading relative" style={{display: 'flex'}}>
                                            <h3 className="ld-fh-element inline-block relative mb-1/35em text-16 uppercase tracking-1">Legal</h3>
                                        </div>
                                        <div className="lqd-fancy-menu lqd-custom-menu relative lqd-menu-td-none">
                                            <ul className="reset-ul">
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400"
                                                    onClick={()=> navigate('/termosdeuso')}
                                                    style={{cursor: 'pointer'}}
                                                    >Termos de Uso</a>
                                                </li>
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400" 
                                                    onClick={()=> navigate('/politicasdeprivacidade')}
                                                    style={{cursor: 'pointer'}}
                                                    >Política de Privacidade</a>
                                                </li>
                                           
                                        
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-33percent sm:w-50percent">
                                    <div className="module-list flex flex-col justify-start mb-30 p-10">
                                        <div className="ld-fancy-heading relative" style={{display: 'flex'}}>
                                            <h3 className="ld-fh-element inline-block relative mb-1/35em text-16 uppercase tracking-1">Entre em contato</h3>
                                        </div>
                                        <div className="lqd-fancy-menu lqd-custom-menu relative lqd-menu-td-none">
                                            <ul className="reset-ul">
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400">Enviar mensagem</a>
                                                </li>
                                                <li className="w-full flex items-center mb-10">
                                                    <a className="w-full flex items-center leading-1/4em text-blue-400">contato@lumera3d.com</a>
                                                </li>
                                                  <li className="w-full flex items-center mb-10">
                                                        <i class="bi bi-instagram" style={{marginRight: '15px'}}></i>
                                                               <i class="bi bi-facebook" style={{marginRight: '15px'}}></i>
                                                                 <i class="bi bi-linkedin" style={{marginRight: '15px'}}></i>
                                                </li>
                                                 
                             
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
              






              
            </section>



            <div 
style={{width: '100%', backgroundColor: '#36363642', height: '30px', fontFamily: 'Inter, serif',
    fontSize: '11px', color: '#323743', display: 'flex', justifyContent: 'center',
    alignItems: 'center', 
}}
>
    © 2025 Lumera 3D - Uma marca Kollabity Engineering Data
</div>







        
        </div>
        
    </main>
 

    </div>







    </div>
  );
}

export default Home;
